// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.desktop .KLvU3y{display:flex;justify-content:center}.desktop .qHzGcK{padding:60px 60px 0 60px}.desktop .qHzGcK.OhkgKE{width:980px;height:120px;padding:0}@media (max-width: 1200px){.desktop .qHzGcK.OhkgKE{width:690px}}.desktop .qHzGcK.a5Uc5C{width:600px;height:338px;margin-bottom:-12px}.mobile .qHzGcK{padding:24px 20px 0 20px}.mobile .qHzGcK.OhkgKE{box-sizing:border-box;padding:20px 20px 12px}.mobile .qHzGcK.a5Uc5C{padding-left:0;padding-right:0;width:100%;height:calc(100vw * 9 / 16);margin-bottom:0px}.YEeJsm{color:#db0000;font-size:12px}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"enclosureWrapper": `KLvU3y`,
	"enclosureContainer": `qHzGcK`,
	"enclosureContainerAudio": `OhkgKE`,
	"enclosureContainerVideo": `a5Uc5C`,
	"error": `YEeJsm`
};
export default ___CSS_LOADER_EXPORT___;
